import React from 'react'
import { Icons } from 'src/ui/icons'
import { TBonusesStepData } from '../organisms/bonuses-steps/types'

export const bonusesStepsData: TBonusesStepData[] = [
  {
    icon: <Icons.PopularSearch />,
    title: 'Посмотри актуальные вакансии',
    subtitle: 'Именно за кандидатов на эти позиции мы готовы выплатить бонус',
  },
  {
    icon: <Icons.CommunicationSend />,
    title: 'Отправь заявку, нажав на кнопку «Рекомендовать друга»',
    subtitle:
      'Мы возьмём её в работу в течение суток. После этого предоставим кандидату тестовое задание и проведём личное собеседование.',
  },
  {
    icon: <Icons.Watch />,
    title: 'Дождись, когда друг завершит испытательный срок',
    subtitle:
      'Для этого нужно успешно пройти собеседование и онбординг в компанию',
  },
  {
    icon: <Icons.CashMoney />,
    title: 'Получи вознаграждение',
    subtitle: 'Наш менеджер напишет тебе и ты получишь вознаграждение',
  },
]
